// import React, { useState } from "react";
// import "../Login.css";
// import { useNavigate } from "react-router-dom";
// import logo from "../../Images/logo3.png";
// import { FaEye, FaEyeSlash } from "react-icons/fa";

// const AdminLogin = () => {
//   const [showPassword, setShowPassword] = useState(false);
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const email = e.target[0].value;
//     const password = e.target[1].value;

//     try {
//       const response = await fetch("https://api.scannscore.com/admin-login", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ email, password }),
//       });

//       const data = await response.json();

//       if (response.ok) {

        
//         localStorage.setItem("admin", JSON.stringify(data));

//         navigate("/admin/dashboard");

//       } else {
//         alert(data.message || "Login failed");
//       }

//     } catch (error) {
//       console.error("Error logging in:", error);
//       alert("An error occurred. Please try again.");
//     }
//   };

//   return (
//     <div className="login-page">
//       <div className="col-lg-5 login-card rounded-5">
//         <div className="px-4 py-5">

//           <img
//             src={logo}
//             alt="logo"
//             className="d-block mx-auto mb-4 bg-white w-25 rounded-circle"
//           />

//           <h2 className="login-title text-center">
//             Login to Your Account
//           </h2>

//           <form onSubmit={handleSubmit}>

//             <input
//               type="email"
//               className="login-input"
//               placeholder="Enter admin email"
//               required
//             />

//             <div style={{ position: "relative" }}>
//               <input
//                 type={showPassword ? "text" : "password"}
//                 className="login-input"
//                 placeholder="Password"
//                 required
//               />

//               <span
//                 onClick={() => setShowPassword(!showPassword)}
//                 style={{
//                   position: "absolute",
//                   right: "15px",
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                   cursor: "pointer",
//                 }}
//               >
//                 {showPassword ? <FaEyeSlash /> : <FaEye />}
//               </span>
//             </div>

//             <button className="login-btn">
//               Submit
//             </button>

//           </form>
//         </div>

//         <div className="bottom-curve rounded-bottom-5"></div>
//       </div>
//     </div>
//   );
// };

// export default AdminLogin;

// import React, { useState } from "react";
// import "../Login.css";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// import logo from "../../Images/logo3.png";
// import { FaEye, FaEyeSlash } from "react-icons/fa";

// const AdminLogin = () => {

//   const navigate = useNavigate();

//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {

//       const response = await axios.post(
//         "https://api.scannscore.com/admin-login",
//         {
//           email: email,
//           password: password
//         }
//       );

//       const data = response.data;

//       // save login
//       localStorage.setItem("admin", JSON.stringify(data));

//       // redirect
//       navigate("/admin/dashboard");
//       window.location.reload();

//     } catch (error) {

//       if (error.response) {
//         alert(error.response.data.message || "Login failed");
//       } else {
//         alert("Server error");
//       }

//     }
//   };

//   return (
//     <div className="login-page">

//       <div className="col-lg-5 login-card rounded-5">

//         <div className="px-4 py-5">

//           <img
//             src={logo}
//             alt="logo"
//             className="d-block mx-auto mb-4 bg-white w-25 rounded-circle"
//           />

//           <h2 className="login-title text-center">
//             Login to Your Account
//           </h2>

//           <form onSubmit={handleSubmit}>

//             <input
//               type="email"
//               className="login-input"
//               placeholder="Enter admin email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//             />

//             <div style={{ position: "relative" }}>

//               <input
//                 type={showPassword ? "text" : "password"}
//                 className="login-input"
//                 placeholder="Password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//               />

//               <span
//                 onClick={() => setShowPassword(!showPassword)}
//                 style={{
//                   position: "absolute",
//                   right: "15px",
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                   cursor: "pointer",
//                 }}
//               >
//                 {showPassword ? <FaEyeSlash /> : <FaEye />}
//               </span>

//             </div>

//             <button type="submit" className="login-btn">
//               Login
//             </button>

//           </form>

//         </div>

//         <div className="bottom-curve rounded-bottom-5"></div>

//       </div>

//     </div>
//   );
// };

// export default AdminLogin;


import React, { useState } from "react";
import "../Login.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import logo from "../../Images/logo3.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AdminLogin = () => {

  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const response = await axios.post(
        "https://api.scannscore.com/admin-login",
        {
          email: email,
          password: password
        }
      );

      const data = response.data;
      // console.log(data.user);


      localStorage.setItem("admin", JSON.stringify(data.user));

     
      toast.success("Login successful!");

      setTimeout(() => {
        navigate("/admin/dashboard");
        window.location.reload();
      }, 1500);

    } catch (error) {

      if (error.response) {
        toast.error(error.response.data.message || "Login failed");
      } else {
        toast.error("Server error");
      }

    }
  };

  return (
    <div className="login-page">

      <div className="col-lg-5 login-card rounded-5">

        <div className="px-4 py-5">

          <img
            src={logo}
            alt="logo"
            className="d-block mx-auto mb-4 bg-white w-25 rounded-circle"
          />

          <h2 className="login-title text-center">
            Login to Your Account
          </h2>

          <form onSubmit={handleSubmit}>

            <input
              type="email"
              className="login-input"
              placeholder="Enter admin email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <div style={{ position: "relative" }}>

              <input
                type={showPassword ? "text" : "password"}
                className="login-input"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "15px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>

            </div>

            <button type="submit" className="login-btn">
              Login
            </button>

          </form>

        </div>

        <div className="bottom-curve rounded-bottom-5">
           <h6
          style={{ cursor: "pointer" }}
           onClick={() => navigate("/Admin-forget-password")}
          >
             Forgot Password
           </h6>
        </div>

      </div>

    
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="colored"
      />

    </div>
  );
};

export default AdminLogin;